<div class="container pb-4 pt-4">
  <app-breadcrumb currentRouteName="Plan du site"></app-breadcrumb>
  <h1 class="pt-3 pb-2">Plan du site</h1>
</div>
